// imports
import Component from 'minsky-kit/js/components/Component';

// private statics
const VERSION = '1.0.0';

// class definition
export default class ScrollHeader extends Component {
    // constructor
    constructor (args = {}, objectName = 'ScrollHeader') {
        args.debug = args.debug || false;
        // super
        super(args, objectName);

        this.upDownOffset = args.upDownOffset || 300;

        this.scrollX = window.scrollX;
        this.scrollY = window.scrollY;

        this.prevScrollY = window.scrollY;

        this.deltaUp = 0;
        this.deltaDown = 0;
    }

    destroy () {
        // super destroy
        super.destroy();
    }

    update () {
        this.checkUpdown();
    }

    checkUpdown () {
        if (this.prevScrollY < window.scrollY) {
            if (this.deltaDown !== true) {
                this.deltaDown += (window.scrollY - this.prevScrollY);
            }
        }
        else {
            if (this.deltaUp !== true) {
                this.deltaUp += (this.prevScrollY - window.scrollY);
            }
        }

        if (this.deltaDown >= this.upDownOffset && this.deltaDown !== true) {
            this.down();
            this.deltaDown = true;
            this.deltaUp = 0;
        }

        if (this.deltaUp >= this.upDownOffset && this.deltaUp !== true) {
            this.up();
            this.deltaUp = true;
            this.deltaDown = 0;
        }

        this.prevScrollY = window.scrollY;
    }

    down () {
        gsap.to(this.$el, { y: -this.$el.offsetHeight, duration: 0.5 });
        // console.log('down');
    }

    up () {
        gsap.to(this.$el, { y: 0, duration: 0.5 });
        // console.log('up');
    }

    // getters & setters
    static get version () { return VERSION; }
}
